import _ from 'lodash'

export const ModeTypes = {
  year: {
    value: 'year',
    label: '年',
  },
  month: {
    value: 'month',
    label: '月',
  },
  week: {
    value: 'week',
    label: '周',
  },
  day: {
    value: 'day',
    label: '日',
  },
  __proto__: {
    get list() {
      return _.map(this)
    },
  },
}

export const WEEK_LABELS = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
